import { Reveal, SectionHeader } from "@/components/Reveal";
import { grussworte } from "@/data/content";

const Grussworte = () => (
  <section id="grussworte" className="grain relative bg-fw-paper py-24 md:py-32" data-testid="grussworte-section">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <SectionHeader kicker="Grußworte" title={grussworte.title} subtitle={grussworte.subtitle} testId="grussworte-header" />

      <div className="space-y-20 md:space-y-28">
        {grussworte.entries.map((e, i) => (
          <div
            key={e.name}
            className={`grid gap-8 md:gap-14 md:grid-cols-12 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
            data-testid={`grusswort-${i}`}
          >
            <Reveal className="md:col-span-4 [direction:ltr]">
              <div className="border-2 border-fw-gold p-2 bg-white shadow-[8px_8px_0px_rgba(176,32,28,0.15)]">
                <img src={e.image} alt={e.name} className="w-full aspect-[3/4] object-cover" />
              </div>
            </Reveal>
            <div className="md:col-span-8 [direction:ltr]">
              <Reveal delay={0.1}>
                <p className="font-heritage italic text-2xl md:text-4xl leading-snug text-fw-navy">
                  <span className="text-fw-red">„</span>
                  {e.quote}
                  <span className="text-fw-red">“</span>
                </p>
              </Reveal>
              <Reveal delay={0.15}>
                <p className="mt-6 font-body text-base md:text-lg text-fw-navy/70 max-w-2xl">{e.text}</p>
              </Reveal>
              <Reveal delay={0.2}>
                <div className="mt-6 flex items-center gap-3">
                  <span className="h-px w-10 bg-fw-red" />
                  <div>
                    <p className="font-technical uppercase tracking-wide text-fw-navy font-bold">{e.name}</p>
                    <p className="font-body text-sm text-fw-red">{e.role}</p>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Grussworte;
